import Immutable, {fromJS} from 'immutable';
import assign from 'lodash/assign';

import {
  RECEIVE_PROCEDURE_LIST,
  RECEIVE_PROCEDURE_DETAIL,
  REQUEST_PROCEDURE_VERSIONS_DETAIL,
  RECEIVE_PROCEDURE_VERSIONS_DETAIL,
  REQUEST_PROCEDURE_VERSIONS_LIST,
  RECEIVE_PROCEDURE_VERSIONS_LIST,
  TOGGLE_ADVANCED_MODE,
  SET_SIDEBAR_LIST_STATE,
  REQUEST_PROCEDURES_DASHBOARD_LIST,
  RECEIVE_PROCEDURES_DASHBOARD_LIST,
  TOGGLE_PROCEDURES_DASHBOARD_RELATION,
  SET_SIDE_DIAGRAM_STATE,
} from './actions';
import {mergeNormalizedFetchData} from 'app/utils/redux';
import {setNormalizedList} from 'app/utils/redux_v2';

const initialState = {
  procedureAdvancedMode: false,

  closedSideDiagrams: {},

  detailPage: {
    procedureVersions: {},
  },
  dashboardSidebar: {},

  // v2 reducers
  byId: {},
  queries: {},
  dashboard: {
    currentFilters: {},
    activeRelations: {},
  },
};

const proceduresPage = (state = Immutable.fromJS(initialState), action) => {
  if (!state.get('hydrated')) {
    state = Immutable.fromJS(
      assign({}, initialState, state.toJS(), {hydrated: true})
    );
  }

  switch (action.type) {
    case RECEIVE_PROCEDURE_LIST:
      return state
        .set(
          'procedures',
          mergeNormalizedFetchData(action.procedures, state.get('procedures'))
        )
        .set('isInvalid', false)
        .set('isFetching', false);

    case RECEIVE_PROCEDURE_DETAIL:
      return state.mergeIn(
        ['byId', action.item.id.toString()],
        Immutable.fromJS(action.item)
      );
    case REQUEST_PROCEDURE_VERSIONS_DETAIL:
      return state.set('isFetching', true);
    case RECEIVE_PROCEDURE_VERSIONS_DETAIL: {
      const path = [
        'detailPage',
        'procedureVersions',
        action.data.version_object_id.toString(),
      ];

      return state.set('isFetching', false).setIn(
        path,
        mergeNormalizedFetchData(
          {
            results: [action.data],
            previous: null,
            next: null,
            count: 1,
          },
          state.getIn(path)
        )
      );
    }

    case REQUEST_PROCEDURE_VERSIONS_LIST:
      return state.set('isFetching', true);

    case RECEIVE_PROCEDURE_VERSIONS_LIST: {
      const path = [
        'detailPage',
        'procedureVersions',
        action.procedureId.toString(),
      ];

      return state.set('isFetching', false).setIn(
        path,
        mergeNormalizedFetchData(
          action.data,
          state.getIn(path),
          // reset allIds if we are fetching the first page
          !!action.data.previous
        )
      );
    }

    case TOGGLE_ADVANCED_MODE: {
      return state.set(
        'procedureAdvancedMode',
        !state.get('procedureAdvancedMode')
      );
    }

    case SET_SIDEBAR_LIST_STATE:
      return state.mergeIn(
        ['dashboardSidebar', action.key],
        Immutable.fromJS(action.state)
      );

    case REQUEST_PROCEDURES_DASHBOARD_LIST:
      return state
        .setIn(['dashboard', 'currentFilters'], fromJS(action.currentFilters))
        .set('isFetching', true);

    case RECEIVE_PROCEDURES_DASHBOARD_LIST:
      return setNormalizedList(action.query, action.response, state).set(
        'isFetching',
        false
      );

    case TOGGLE_PROCEDURES_DASHBOARD_RELATION: {
      const path = ['dashboard', 'activeRelations', action.relation];
      const value = state.getIn(path);
      return value === true ? state.deleteIn(path) : state.setIn(path, true);
    }

    case SET_SIDE_DIAGRAM_STATE: {
      return state.setIn(
        ['closedSideDiagrams', action.procedureId.toString()],
        action.closed
      );
    }

    default:
      return state;
  }
};

export default proceduresPage;
